import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { NextLoading } from "./utils/loading/loading";

import { useStore } from 'vuex';
import { watch, onMounted, toRaw } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const store = useStore();
    watch(() => store.state.systemSet.activeTheme, (count, prevCount) => {
      document.body.setAttribute("data-theme", count);
    });
    onMounted(() => {
      // 界面 loading 动画开始执行
      if (window.nextLoading === undefined) NextLoading.start();
      let activeTheme = toRaw(store.state.systemSet.activeTheme);
      if (activeTheme) {
        document.body.setAttribute("data-theme", activeTheme);
      } else {
        let activeTheme = "theme-drak-green-classics";
        document.body.setAttribute("data-theme", activeTheme);
        store.commit("ACTIVE_THEME_SET", activeTheme);
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});